import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export default function Terms() {
  const currentDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <div className="min-h-screen flex flex-col">
      <header className="glass fixed top-0 left-0 right-0 z-50 h-16 px-6 flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <img src="/mishu_svg.svg" alt="mishu" className="h-8 w-auto" />
        </div>
        <Button asChild variant="ghost">
          <Link to="/">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Link>
        </Button>
      </header>

      <main className="flex-1 pt-24 px-6 pb-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
          <p className="text-muted-foreground mb-8">Last Updated: {currentDate}</p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
            <p className="mb-4">
              Welcome to mishu ("the Service"). This Service is provided by Kinesis LTD. ("we," "us," or "our"). 
              By using this Service, you agree to comply with and be bound by these Terms of Service. If you do not agree with 
              any part of these terms, please discontinue use of the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-3">2. Service Description</h2>
            <p className="mb-4">
              mishu is a parental monitoring tool that helps parents and guardians track their child's WhatsApp 
              activity for safety purposes. The Service leverages AI-powered moderation models to analyze WhatsApp messages and 
              alert users of potential risks such as cyberbullying, explicit content, or harmful interactions.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-3">3. User Obligations</h2>
            <p className="mb-4">By using the Service, you agree to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Use the Service only for lawful and ethical purposes.</li>
              <li>Ensure that you have obtained the necessary legal consent to monitor a child's WhatsApp activity.</li>
              <li>Not misuse the Service for unauthorized surveillance or illegal activities.</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-3">4. Termination & Account Deletion</h2>
            <p className="mb-4">
              Users can terminate their account at any time. Upon termination, all associated data, including stored messages 
              and alerts, will be permanently deleted.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-3">5. Changes to These Terms</h2>
            <p className="mb-4">
              We reserve the right to update these Terms periodically. Users will be notified of any material changes via 
              email or through the Service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold mb-3">6. Contact Information</h2>
            <p className="mb-4">If you have any questions regarding these Terms, please contact us at:</p>
            <p className="mb-4">Email: <a href="mailto:legal@knesis.com" className="text-primary hover:underline">legal@knesis.com</a></p>
          </section>

          <p className="italic text-muted-foreground">
            By using the Service, you confirm that you have read and agreed to these Terms.
          </p>
        </div>
      </main>

      <footer className="border-t py-6 px-6">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground mb-4 sm:mb-0">
            © {new Date().getFullYear()} mishu. All rights reserved.
          </p>
          <div className="flex space-x-4">
            <Link
              to="/terms"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy
            </Link>
            <a
              href="mailto:legal@knesis.com"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
